var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 24,
    fill: "none",
    xmlnsV: "https://vecta.io/nano",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.908 7h-9a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    y: -4
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    y: -8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.908 6a1.5 1.5 0 0 0-1.061 2.561A1.5 1.5 0 0 0 5.408 7.5a1.5 1.5 0 0 0-1.5-1.5zm0 2a.5.5 0 0 1-.354-.854.5.5 0 0 1 .854.354.5.5 0 0 1-.5.5zm17.878-3a2.6 2.6 0 0 0-1.853.768l-1.379 1.379-.146.146V3.5a1.5 1.5 0 0 0-1.5-1.5h-2.592a1.5 1.5 0 0 0-1.408-1h-1.774a1.99 1.99 0 0 0-1.726-1 1.99 1.99 0 0 0-1.726 1H5.908A1.5 1.5 0 0 0 4.5 2H1.908a1.5 1.5 0 0 0-1.5 1.5v19a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5v-7.794l3.85-3.85 1.377-1.377A2.62 2.62 0 0 0 21.786 5zM5.408 2.5a.5.5 0 0 1 .5-.5H8a.5.5 0 0 0 .471-.333.99.99 0 0 1 1.874-.001.5.5 0 0 0 .471.333h2.092a.5.5 0 0 1 .5.5V3h-8v-.5zm12 20a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5v-19a.5.5 0 0 1 .5-.5h2.5v.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V3h2.5a.5.5 0 0 1 .5.5v4.793l-2.77 2.77a.49.49 0 0 0-.23-.063h-7.5a.5.5 0 1 0 0 1h6.793l-3 3H6.908a.5.5 0 1 0 0 1h3.36l-.75 3h-2.61a.5.5 0 1 0 0 1h3a.45.45 0 0 0 .121-.016l4-1c.012 0 .02-.014.032-.018a.5.5 0 0 0 .169-.1c.009-.008.023-.009.032-.018l3.146-3.142V22.5zm-6.128-6.423a3.16 3.16 0 0 1 1.274.777c.356.357.623.794.777 1.274l-2.736.685.685-2.736zm2.893 1.45a4.13 4.13 0 0 0-2.292-2.292l7.027-7.027L21.2 10.5l-7.027 7.027zm8.76-8.76l-1.025 1.026L19.615 7.5l1.026-1.027a1.62 1.62 0 1 1 2.293 2.293v.001z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "B",
    d: "M3.908 18a1.5 1.5 0 0 0-1.386.926 1.5 1.5 0 0 0 .325 1.635 1.5 1.5 0 0 0 1.635.325 1.5 1.5 0 0 0 .926-1.386 1.5 1.5 0 0 0-1.5-1.5zm0 2a.5.5 0 0 1-.462-.309.5.5 0 0 1 .108-.545.5.5 0 0 1 .545-.108.5.5 0 0 1 .309.462.5.5 0 0 1-.5.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.f2952e9b760119406dd096f492854bdd.svg";
export { ForwardRef as ReactComponent };